var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolyGridLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 677,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#poly-grid-left_svg__clip0_6539_2606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.54 675l135.857-26.92M185.54 675l120.398-124.862M185.54 675V559.434m0 115.566L2 386.179M321.397 648.08l-15.459-97.942m15.459 97.942l32.739-34.503m-48.198-63.439l48.198 63.439m-48.198-63.439l83.091-28.25m-83.091 28.25l-120.398 9.296m120.398-9.296l5.287-57.491M185.54 559.434l125.685-66.787M185.54 559.434l99.163-181.646M185.54 559.434L2 386.179m183.54 173.255l-32.281-147.897M2 386.179l12.805-202.92M2 386.179l101.373-93.482M2 386.179l151.259 25.358m200.877 202.04l34.893-91.689m0 0l-77.804-29.241m77.804 29.241l-46.876-95.777m-30.928 66.536l30.928-66.536m-30.928 66.536l-26.522-114.859m57.45 48.323L446 350.809m-161.297 26.979l-131.444 33.749m131.444-33.749L446 350.809m-161.297 26.979L302.59 210.89M153.259 411.537l-49.886-118.84M446 350.809L399.338 210.89M446 350.809L302.59 210.89m0 0l-25.641-75.829m25.641 75.829h96.748M14.805 183.259l126.05-73.93m-126.05 73.93l195.002 39.154M14.805 183.259l88.568 109.438m0 0l106.434-70.284m-68.952-113.084l49.92-47.496m-49.92 47.496l86.487 36.511m-86.487-36.511l68.952 113.084m0 0l17.535-76.573m-36.567-84.007l36.567 84.007m-36.567-84.007L329.675 2M227.342 145.84l49.607-10.779M329.675 2l-52.726 133.061M329.675 2l56.005 102.704 13.658 106.186M329.675 2l15.282 110.437m-68.008 22.624l68.008-22.624m-68.008 22.624l40.676 51.486 81.713 24.343m0 0l-54.381-98.453",
    stroke: "url(#poly-grid-left_svg__paint0_linear_6539_2606)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "poly-grid-left_svg__paint0_linear_6539_2606",
    x1: 43.407,
    y1: 345.978,
    x2: 153.16,
    y2: 345.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6f2a7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "poly-grid-left_svg__clip0_6539_2606"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h448v677H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyGridLeft);
export default __webpack_public_path__ + "static/media/poly-grid-left.8c54a0f585776d50ff33a6c5db5015b7.svg";
export { ForwardRef as ReactComponent };